module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "list-transition"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("Add")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-block",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Remove")])])]), _vm._v(" "), _c('transition-group', {
    staticClass: "segment",
    attrs: {
      "name": "list",
      "tag": "p"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('span', {
      key: item,
      staticClass: "list-item"
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6987ae62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list-transition.vue
// module id = 96
// module chunks = 0